package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.dto.weather.WeatherDayDto
import com.evoapps.evoshift.data.remote.AppFirestore
import com.evoapps.evoshift.data.remote.ListenerErrors
import com.evoapps.evoshift.domain.model.DayWeather
import com.evoapps.evoshift.domain.repository.WeatherRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.map
import kotlinx.datetime.LocalDate

/**
 * SH-226: `workplaces/{id}/weather/{YYYY-MM-DD}`, written only by functions/weather.js (Admin SDK);
 * the workplace's members read it (firestore.rules). The app never asks a weather service itself.
 * A refused or failed listener is an empty map: weather is an extra, never a reason for an error.
 */
class WeatherRepositoryImpl(private val firestore: AppFirestore) : WeatherRepository {

    override fun observeDays(workplaceId: String, from: LocalDate, to: LocalDate): Flow<Map<LocalDate, DayWeather>> =
        firestore.collection("workplaces").document(workplaceId).collection(COLLECTION)
            .where { "date" greaterThanOrEqualTo from.toString() }
            .where { "date" lessThanOrEqualTo to.toString() }
            .snapshots
            .map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    runCatching { doc.data<WeatherDayDto>().toDomain(fallbackDate = doc.id) }.getOrNull()
                }.associateBy { it.date }
            }
            .catch { e ->
                ListenerErrors.report(e)
                emit(emptyMap())
            }
            .distinctUntilChanged()

    companion object {
        const val COLLECTION = "weather"
    }
}
